import 'style/default.less'
import * as defaultCompStyle from 'theme/components/default.module.less'
import * as defaultStyle from 'theme/default.module.less'

import { extendComponentsToken, extendToken } from './application'

extendToken(defaultStyle)
extendComponentsToken(defaultCompStyle)
